import { Icon, Text } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import ConfirmMenuItem from "components/Shared/ConfirmModal/ConfirmMenuItem";
import { MdPublish } from "react-icons/md";
import { useAdminMutation } from "utils/apollo/hooks/admin";

const fragment = gql(/* GraphQL */ `
  fragment OrderingPlatformMakeDefaultMenuItemFragment on OrderingPlatform {
    id
    name
    isParent
    forBrand {
      id
      name
    }
    directRetailer {
      id
      forBrandId
    }
    parent {
      id
      forBrandId
    }
  }
`);

const mutation = gql(/* GraphQL */ `
  mutation MakeOrderingPlatformDefault($orderingPlatformId: UUID!) {
    updateOrderingPlatform(
      input: { id: $orderingPlatformId, patch: { forBrandId: null } }
    ) {
      orderingPlatform {
        id
        forBrandId
        forBrand {
          id
        }
        ...CustomerIsCustomBadge
      }
    }
  }
`);

type Props = {
  orderingPlatform: FragmentType<typeof fragment>;
};

export default function OrderingPlatformMakeDefaultMenuItem({
  orderingPlatform,
}: Props) {
  const op = getFragmentData(fragment, orderingPlatform);

  const mutationTuple = useAdminMutation(mutation, {
    variables: { orderingPlatformId: op.id },
  });

  return (
    <ConfirmMenuItem
      mutation={mutationTuple}
      label="Convert to Default…"
      menuItemProps={{
        icon: <Icon as={MdPublish} />,
        isDisabled:
          !op.forBrand ||
          op.isParent ||
          !!op.directRetailer?.forBrandId ||
          !!op.parent?.forBrandId,
      }}
      confirmText={
        <>
          <Text>
            By converting this custom customer, <strong>{op.name}</strong>, for{" "}
            <strong>{op.forBrand?.name}</strong> to be a default customer, it
            will immediately become available for all brands to add.{" "}
            {op.forBrand?.name} will no longer be able to edit this customer’s
            details.
          </Text>

          <Text mt={3} fontWeight={600}>
            Are you sure you want to convert <strong>{op.name}</strong> to be a
            default customer?
          </Text>
        </>
      }
    />
  );
}
